/** @jsxRuntime automatic */
/** @jsxImportSource react */
import React, { useEffect, useState } from "react"

// Keep partial input local so typing a number never clamps an intermediate digit.
export function EditorNumberInput(props) {
  const [draft, setDraft] = useState(String(props.value))
  useEffect(() => setDraft(String(props.value)), [props.value])
  const commit = () => {
    const parsed = Number(draft)
    const value =
      draft.trim() && Number.isFinite(parsed)
        ? Math.max(props.min, Math.min(props.max, Math.trunc(parsed)))
        : props.value
    setDraft(String(value))
    if (value !== props.value) props.onChange(value)
  }
  return (
    <input
      className="datox-react-dashboard__input"
      type="number"
      aria-label={props.label}
      min={props.min}
      max={props.max}
      step="1"
      disabled={props.disabled}
      value={props.disabled ? String(props.value) : draft}
      onChange={(event) => setDraft(event.currentTarget.value)}
      onBlur={commit}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault()
          commit()
        }
      }}
    />
  )
}

export function EditorSection(props) {
  return (
    <details
      className="datox-react-dashboard__editor-details datox-react-dashboard__settings-section"
      open={props.open}
    >
      <summary>
        <span>{props.title}</span>
        {props.badge != null ? <span className="datox-react-dashboard__settings-badge">{props.badge}</span> : null}
      </summary>
      <div className="datox-react-dashboard__settings-content">{props.children}</div>
    </details>
  )
}
